import React, { useState } from 'react';
import { ResponsiveChord } from '@nivo/chord';
import { Layout, Space, Slider, Typography, Row, Divider, Col } from 'antd';
import { SettingOutlined } from '@ant-design/icons';

const { Sider, Content } = Layout;

const CustomRibbonTooltip = ({ ribbon }) => (
  <div style={{ background: 'white', padding: '9px', border: '1px solid black' }}>
    <strong>Relationship:</strong>
    <br />
    From: {ribbon.source.id} to {ribbon.target.id}
    <br />
    Value: {ribbon.source.value.toFixed(1)} to {ribbon.target.value.toFixed(1)}
  </div>
);

const NivoChordChart = ({ matrix, keys, legend = false, height=800 }) => {
  const [padAngle, setPadAngle] = useState(0.01);
  const [ribbonOpacity, setRibbonOpacity] = useState(0.5);
  const [innerRadiusRatio, setInnerRadiusRatio] = useState(0.96);

  const legendConfig = [
    {
      anchor: 'bottom',
      direction: 'row',
      justify: false,
      translateX: 0,
      translateY: 70,
      itemsSpacing: 2,
      itemWidth: 60,
      itemHeight: 14,
      itemTextColor: '#000',
      itemDirection: 'left-to-right',
      symbolSize: 12,
      effects: [
        {
          on: 'hover',
          style: {
            itemTextColor: '#000'
          }
        }
      ]
    }
  ];

  return (
    <>
        <Row justify={'start'} wrap={false}>
            <Col flex={'1'}>
                <div style={{height, width: '100%'}}>
                    <ResponsiveChord
                      data={matrix}
                      keys={keys}
                      margin={{ top: 30, right: 30, bottom: 30, left: 30 }}
                      valueFormat=".2f"
                      padAngle={padAngle}
                      innerRadiusRatio={innerRadiusRatio}
                      innerRadiusOffset={0.02}
                      arcOpacity={1}
                      arcBorderWidth={0}
                      arcBorderColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
                      ribbonOpacity={ribbonOpacity}
                      ribbonBorderWidth={1}
                      ribbonBorderColor={{ from: 'color', modifiers: [['darker', 0.25]] }}
                      label="id"
                      labelOffset={12}
                      labelRotation={-90}
                      labelSkipWidth={12}
                      labelTextColor={{ from: 'color', modifiers: [['darker', 1.5]] }}
                      colors={{ scheme: 'purple_orange' }}
                      isInteractive={true}
                      arcHoverOpacity={1}
                      arcHoverOthersOpacity={0.25}
                      ribbonHoverOpacity={0.75}
                      ribbonHoverOthersOpacity={0.25}
                      animate={true}
                      motionStiffness={90}
                      motionDamping={7}
                      ribbonTooltip={CustomRibbonTooltip}
                      legends={legend ? legendConfig : []}
                    />
                </div>
            </Col>
            <Col flex={'0 0 150px'}>
                <Space direction={'vertical'}>
                    <Typography.Text strong={true}>Pad Angle</Typography.Text>
                    <Slider
                              min={0.01}
                              max={0.12}
                              step={0.01}
                              value={padAngle}
                              onChange={setPadAngle}
                              style={{width: 200}}
                    />
                </Space>
                <Space direction={'vertical'}>
                    <Typography.Text strong={true}>Inner Radius Ratio</Typography.Text>
                    <Slider
                                  min={0}
                                  max={1}
                                  step={0.1}
                                  value={ribbonOpacity}
                                  onChange={setRibbonOpacity}
                                  style={{width: 200}}
                    />
                </Space>
            </Col>
        </Row>
    </>
  );
};

export default NivoChordChart;